// Where each role's "home" lives. Employees and contractors have no dashboard,
// so sending them to /dashboard lands them on a route they can't access.
export const homeRouteFor = (role) => {
  switch (role) {
    case "employee":
      return "/EmpAttendance";
    case "contractor":
      return "/contractordetails";
    case "admin":
    case "staff":
    case "Super Admin":
      return "/dashboard";
    default:
      return "/";
  }
};
